var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFilters,
              expression: "showFilters"
            }
          ],
          staticClass: "col-4"
        },
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
            [
              _c("card-search-filter", {
                ref: "cardSearchFilter",
                on: { fetch: _vm.fetchData }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "q-scroll-area",
            { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
            [
              _c("q-table", {
                attrs: {
                  title: _vm.tableTitle,
                  data: _vm.items,
                  columns: _vm.getColumns,
                  "row-key": "_oid",
                  pagination: _vm.pagination,
                  "rows-per-page-options": _vm.rowsPerPage,
                  separator: "horizontal",
                  filter: _vm.tableFilter,
                  dense: ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "top-left",
                    fn: function(props) {
                      return [
                        _c("q-toggle", {
                          attrs: { icon: "input" },
                          model: {
                            value: _vm.showFilters,
                            callback: function($$v) {
                              _vm.showFilters = $$v
                            },
                            expression: "showFilters"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "top-right",
                    fn: function(props) {
                      return [
                        _c("q-search", {
                          staticClass: "col-6",
                          attrs: {
                            "hide-underline": "",
                            color: "secondary",
                            placeholder: "filtruj.."
                          },
                          model: {
                            value: _vm.tableFilter,
                            callback: function($$v) {
                              _vm.tableFilter = $$v
                            },
                            expression: "tableFilter"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "body-cell-_cid",
                    fn: function(props) {
                      return _c(
                        "q-td",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-btn",
                            {
                              attrs: {
                                round: "",
                                dense: "",
                                icon: "edit",
                                color: "primary",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.objectClick(props.row)
                                }
                              }
                            },
                            [
                              !_vm.$q.platform.is.mobile
                                ? _c("q-tooltip", [
                                    _vm._v("przejdź do obiektu")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  },
                  {
                    key: "body-cell-_oid",
                    fn: function(props) {
                      return _c("q-td", { attrs: { props: props } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(props.value) +
                            "\n            "
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }